import { useQuery } from "react-query";
import { api, ApiError } from "utils/api";
import { UserSearchResponse } from "../types";

const postAdminUserSearch = (query: string): Promise<UserSearchResponse> => {
  const options = {
    method: "POST",
    body: JSON.stringify({ query }),
  };
  return api(`/admin/users`, options);
};

const useAdminUserSearch = (query?: string) =>
  useQuery<UserSearchResponse, ApiError>(
    ["project-search", query],
    () => postAdminUserSearch(query as string),
    {
      enabled: !!query,
    }
  );

export { useAdminUserSearch };
